import React from "react";
import '../styles/MainSubtitle.css';
import { Link, useLocation } from "react-router-dom";

function MainSubtitle() {

    const location = useLocation();

    const getSubtitleText = () => {
        switch (location.pathname) {
            case '/menu':
                return (
                    <div className="mb-0 fs-5"><Link to={'/'} state={{ scrollToDish: true }} className="fw-semibold text-green-dark fs-5">Obiad dnia</Link> - Zupa + II danie w doskonałej cenie</div>
                );
            case '/galeria':
                return 'Od lat serwujemy dania inspirowane kuchnią polską, tworząc miejsce, w którym każdy gość czuje się jak w domu.'
            case '/kontakt':
                return 'Chętnie odpowiemy na wszystkie Twoje pytania i pomożemy zorganizować niezapomniane spotkanie w naszej restauracji.'
            default:
                return 'Od lat serwujemy dania inspirowane kuchnią polską, tworząc miejsce, w którym każdy gość czuje się jak w domu.'
        }
    }



    return (

        <div className="container-fluid main-subtitle-section-background py-4 my-5-5">
            <div className="container text-center d-flex justify-content-center align-items-center">
                <div className="m-0">{getSubtitleText()}</div>
            </div>
        </div>

    )
}

export default MainSubtitle;